// MAP SIZE
// Max and min number of pixels that map can expand to
export const MAP_MAX_WIDTH = 800;
export const MAP_MIN_WIDTH = 220;

// MAP TILE FONT SIZE
// Max is reached when viewport width is more than MID_BREAKPOINT.
// Min is reached when viewport is less than MAP_MIN_WIDTH
export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 20;

// BREAKPOINTS
// Change styles based on this screen size
export const MID_BREAKPOINT = 550;
